import { render, staticRenderFns } from "./TenthSection.vue?vue&type=template&id=1f4102ce&"
import script from "./TenthSection.vue?vue&type=script&lang=ts&"
export * from "./TenthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports